var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardRedz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2339 24.7827C18.8613 24.7827 24.2339 19.4101 24.2339 12.7827C24.2339 6.1553 18.8613 0.782715 12.2339 0.782715C5.60647 0.782715 0.233887 6.1553 0.233887 12.7827C0.233887 19.4101 5.60647 24.7827 12.2339 24.7827Z",
    fill: "#97144D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2267 12.6827L10.5803 15.3292C10.385 15.5244 10.385 15.841 10.5803 16.0363C10.7755 16.2316 11.0921 16.2316 11.2874 16.0363L14.2874 13.0363C14.4827 12.841 14.4827 12.5244 14.2874 12.3292L11.2874 9.32919C11.0921 9.13392 10.7755 9.13392 10.5803 9.32919C10.385 9.52445 10.385 9.84103 10.5803 10.0363L13.2267 12.6827Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardRedz);
export default __webpack_public_path__ + "static/media/forwardRedz.3ec3ef389e4a3e24b9d8d401f23fb2da.svg";
export { ForwardRef as ReactComponent };